import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './ServiceUseGuide.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import URL from '../../../../constants/url';
import noDataImg from '../../../../images/common/i_3d_no_data_doc.svg';

import HeadSub from '../../../../components/comm/HeadSub';


import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import { formatDate } from '../../../../assets/js/comm';

import ToastPopup from '../../../../components/comm/ToastPopup';

import Skeleton from '@mui/material/Skeleton';

const PAGE_SIZE = 30;

const ServiceUseGuide = () => {

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const location = useLocation();
    const navigate = useNavigate();

    const [bbsList, setBbsList] = useState([]); //게시물 목록
    const [pageNo, setPageNo] = useState(1);
    const [hasNext, setHasNext] = useState(true);

    const observerRef = useRef(null);
    const scrollObserver = useRef(null);
    const isFirstApiCalled = useRef(false);

    const [isInitialLoading, setIsInitialLoading] = useState(true); // 초기 로딩 상태 추가

    const retrieveBbsList = useCallback(async (pageNo) => {
        const url = "/notices/retrieveBbsList";
        const jToken = localStorage.getItem('jToken');
        const reqOptions = { headers: { Authorization: jToken } };

        // 1	자주하는 질문
        // 2	공지사항 게시판
        // 3	서비스 약관 및 정책
        // 4	서비스 이용 가이드
        // 5	오류 제보 관리

        await axiosApi.post(url, {bbsMasId : 4, pageNo: pageNo, pageSize: PAGE_SIZE }, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setBbsList(prev => [...prev, ...res.data.result.bbsList]);
                console.log(res.data.result.bbsList)
                if (!res.data.result.hasNext) setHasNext(false);
            } else {
                setHasNext(false);
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
            setIsInitialLoading(false); // 초기 로딩 완료
        })
        .catch(err => {
            setHasNext(false);
            console.error("게시물 목록 결과 호출 중 오류  : ", err);
        })
    }, []);

    // ✅ 최초 한 번만 호출
    useEffect(() => {
        if (!isFirstApiCalled.current) {
        isFirstApiCalled.current = true;
        setTimeout(() => {
            retrieveBbsList(1);
        }, 50);
        }
    }, []);

    // ✅ pageNo 변경 시 (2 이상) 호출
    useEffect(() => {
        if (pageNo > 1 && hasNext) {
        retrieveBbsList(pageNo);
        }
    }, [pageNo]);

    // ✅ observer는 데이터가 렌더링된 이후에만 등록
    useEffect(() => {
        if (!hasNext || bbsList.length === 0) return;

        // 기존 observer 제거
        if (scrollObserver.current && observerRef.current) {
            scrollObserver.current.unobserve(observerRef.current);
        }

        scrollObserver.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
            setPageNo(prev => prev + 1);
        }
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 1.0
        });

        if (observerRef.current) {
        scrollObserver.current.observe(observerRef.current);
        }

        return () => {
        if (scrollObserver.current && observerRef.current) {
            scrollObserver.current.unobserve(observerRef.current);
        }
        };
    }, [bbsList.length, hasNext]);



    const handleOnLink = (joinUrl) => {
        // React Native 에서 처리
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: joinUrl
            }));
        } else {
            // 일반 웹 브라우저
            window.open(joinUrl, '_blank', 'noopener,noreferrer');
        }
    }
    
    return (
        <>
            <HeadSub title="서비스 이용가이드" />

            <div id="sub-content">
                <div className='inner-wrap' data-pad="normal">

                        <div className={style['guide-lists-box']}>
                            <ul>

                            {/* 초기 로딩 중일 때 스켈레톤 표시 */}
                            {/* {isInitialLoading && (
                                <>
                                    {[...Array(5)].map((_, idx) => (
                                        <li key={'skeleton_' + idx}>
                                            <p className={style['title']}>
                                                <Skeleton variant="text" width="140px" height={24} style={{ marginBottom: '8px' }} />
                                            </p>
                                        </li>
                                    ))}
                                </>
                            )} */}

                            {/* {!isInitialLoading && bbsList.length > 0 &&
                                bbsList.map((item, idx) => {
                                    return(
                                        <li key={'bbs_' + idx} onClick={()=> {
                                                        navigate(URL.SERVICE_USE_GUIDE_DETAIL, {
                                                            state: {
                                                                bbsMasId: item.bbsMasId,
                                                                bbsNttId: item.bbsNttId
                                                            }                                                                     
                                                        })}}>
                                            <p className={style['title']}>{item.nttSj}</p>
                                        </li>
                                    )
                                })
                                
                            } */}

                            {/* {!isInitialLoading && bbsList.length === 0 &&
                                <li className={style['no-data-box']}>
                                    <div className={style['img-box']}>
                                        <object data={noDataImg} aria-hidden='true'></object>
                                    </div>
                                    <p>이용 가이드가 없습니다.</p>
                                </li>
                            } */}

                                <li onClick={()=> handleOnLink('https://digitalpharm.notion.site/2a21740750038010810dd12c5d85fdd3')}>
                                    <p className={style['title']}>케어플러스란 무엇인가요?</p>
                                </li>    
                                <li onClick={()=> handleOnLink('https://digitalpharm.notion.site/2a217407500380d1a05be379a458db4b')}>
                                    <p className={style['title']}>홈케어 &gt; 건강 기록 가이드</p>
                                </li>    
                                <li onClick={()=> handleOnLink('https://digitalpharm.notion.site/2a217407500380fbb92df5295f395eca')}>
                                    <p className={style['title']}>홈케어 &gt; 복약 기록 가이드</p>
                                </li>    
                                <li onClick={()=> handleOnLink('https://digitalpharm.notion.site/2a217407500380d2994cfe84a98934e3')}>
                                    <p className={style['title']}>홈케어 &gt; 영양 챗봇 가이드</p>
                                </li>    

                            </ul>
                            <div ref={observerRef} style={{ height: '1px' }} />
                        </div>
                    

                </div>
            </div>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    );
};

export default ServiceUseGuide;
